import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import { CBadge } from '@coreui/react-pro'

export const AppSidebarNav = ({ items }) => {
  const user = JSON.parse(localStorage.getItem("user"))

  const location = useLocation()
  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && name}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    )
  }

  const navItem = (item, index) => {
    const { component, name, badge, icon, roles, ...rest } = item
    const Component = component
    if (user?.role_id) {
      if (roles.includes(user?.role_id)) {
        return (
          <Component
            className='mt-3'
            {...(rest.to &&
              !rest.items && {
              component: NavLink,
            })}
            key={index}
            {...rest}
          >
            {navLink(name, icon, badge)}
          </Component>
        )
      }
    }
  }
  const navGroup = (item, index) => {
    const { component, name, icon, to, roles, ...rest } = item
    const Component = component
    if (user?.role_id) {
      if (roles.includes(user?.role_id)) {
        return (
          <Component
            className='mt-3'
            idx={String(index)}
            key={index}
            toggler={navLink(name, icon)}
            visible={location.pathname.startsWith(to)}
            {...rest}
          >
            {item.items?.map((item, index) =>
              item.items ? navGroup(item, index) : navItem(item, index),
            )}
          </Component>
        )
      }
    }
  }

  return (
    <React.Fragment>
      {items &&
        items.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
    </React.Fragment>
  )
}
